import { FC } from "react";
import { useRouter } from "next/router";
import classNames from "classnames";
import { ArrowSmLeftIcon } from "@heroicons/react/solid";
import { ImegaMenuMainItem } from "features/home/helpers/types";

interface IProps {
  megaMenuItem: ImegaMenuMainItem;
  activeLevel: ImegaMenuMainItem | undefined;
  onMouseOver?: () => void;
}
const MegaMenuChild: FC<IProps> = ({
  megaMenuItem,
  activeLevel,
  onMouseOver,
}) => {
  const router = useRouter();
  const onClickHandler = (url: string) => {
    router.push(url);
  };
  const browserHeight = window ? window.innerHeight : 0;

  return (
    <div
      className={classNames(
        " h-[484px] w-[280px] max-h-[70vh] bg-zinc-50 flex-col  px-3 overflow-y-scroll overflow-x-hidden scrollMenu hidden",
        activeLevel && activeLevel.id === megaMenuItem.id ? "!flex" : "",
        { "max-h-[60vh]": browserHeight <= 500 }
      )}
      onMouseOver={onMouseOver}
    >
      <a
        href={megaMenuItem.url}
        onClick={() => onClickHandler(megaMenuItem.url)}
        className="h-11  min-h-11  items-center flex  cursor-pointer title-sm text-fds-brand "
      >
        <span>همه آموزش‌های {megaMenuItem?.name}</span>
        <ArrowSmLeftIcon className="h-4 w-4 mr-2" />
      </a>

      {megaMenuItem?.children?.map((child) => {
        return (
          <a
            href={child.url}
            onClick={() => onClickHandler(child.url)}
            className=" w-full cursor-pointer items-center flex  title-sm text-fds-primary hover:text-fds-brand min-h-11   h-11"
            key={child.id}
          >
            {child.name}
          </a>
        );
      })}
    </div>
  );
};

export default MegaMenuChild;
